/**
 * Frozen configuration presets for useVideoRecorder.
 */

export const MIME_PRIORITY_DEFAULT = Object.freeze([
  "video/webm;codecs=vp9,opus",
  "video/webm;codecs=vp8,opus",
  "video/webm",
  "video/mp4",
]);

export const MIME_PRIORITY_VENDOR = Object.freeze([
  "video/webm;codecs=vp9,opus",
  "video/webm;codecs=vp8,opus",
  "video/mp4;codecs=avc1.42E01E,mp4a.40.2",
  "video/webm",
  "video/mp4",
]);

export const ACCEPTED_VIDEO_TYPES = "video/mp4,video/webm,video/quicktime";

export const customerRecorderConfig = Object.freeze({
  maxDurationSeconds: 15,
  countdownSeconds: 3,
  timerDirection: "down",
  flashAtRemainingSeconds: null,
  autoSetupStream: true,
  videoBitsPerSecond: null,
  audioBitsPerSecond: null,
  videoKeyFrameIntervalMs: null,
  getUserMediaConstraints: Object.freeze({
    audio: Object.freeze({ echoCancellation: true }),
    video: Object.freeze({ facingMode: "user" }),
  }),
  mimePriority: MIME_PRIORITY_DEFAULT,
  maxFileDurationSeconds: null,
});

export const vendorRecorderConfig = Object.freeze({
  maxDurationSeconds: 300,
  countdownSeconds: 3,
  timerDirection: "up",
  flashAtRemainingSeconds: 10,
  autoSetupStream: false,
  videoBitsPerSecond: 2500000,
  audioBitsPerSecond: 128000,
  videoKeyFrameIntervalMs: 2000,
  getUserMediaConstraints: Object.freeze({
    video: Object.freeze({
      frameRate: Object.freeze({ min: 24, ideal: 30, max: 30 }),
    }),
    audio: true,
  }),
  mimePriority: MIME_PRIORITY_VENDOR,
  maxFileDurationSeconds: null,
});
